import {Inject, Injectable} from '@angular/core';
import {BehaviorSubject, Observable, of, Subscription, timer} from 'rxjs';
import {Unit} from '../unit';
import {concatMap, distinctUntilChanged, expand, filter, switchMap, tap, withLatestFrom} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {UnitStatusModel} from '../../../unit-status-manager/unit-status.model';
import * as lodash from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class DashboardSelectedUnitCacheService {
  protected skipUnitIfRefreshInProgress = {};
  public selectedUnit: BehaviorSubject<Unit> = new BehaviorSubject<Unit>(null);
  protected selectedUnitPollSubscription: Subscription;
  protected selectedUnitIdSubscription: Subscription;
  protected refreshInterval = 5000;

  constructor(
    public http: HttpClient,
    @Inject('ENVIRONMENT_VERSION') protected environmentVersion,
    @Inject('ENVIRONMENT_API_BASEPOINT') protected environmentApiBasepoint
  ) {
  }

  public start(selectedUnitIdObservable: Observable<number>) {
    this.selectedUnitIdSubscription = selectedUnitIdObservable.pipe(
      distinctUntilChanged(),
    ).subscribe(
      selectedUnitId => {
        if (this.selectedUnitPollSubscription) {
          this.selectedUnitPollSubscription.unsubscribe();
          this.selectedUnit.next(null);
        }
        if (selectedUnitId) {
          const pollObservable = this.unitDataOobservable(selectedUnitId);
          this.selectedUnitPollSubscription = pollObservable
            .pipe(
              expand(x => timer(this.refreshInterval).pipe(concatMap(y => pollObservable)))
            ).subscribe();
        }
      }
    );

  }

  public stop() {
    [
      this.selectedUnitPollSubscription,
      this.selectedUnitIdSubscription
    ].filter(s => !!s).forEach(s => s.unsubscribe());
    this.selectedUnit.next(null);
  }

  public updateUnitStatus(unitId: number, status: UnitStatusModel) {
    this.skipUnitIfRefreshInProgress[unitId] = true;
    const selectedUnit = this.selectedUnit.getValue();
    if (selectedUnit && selectedUnit.id === unitId) {
      const updatedUnit: Unit = lodash.cloneDeep(selectedUnit);
      updatedUnit.unit_status_id = status.id;
      this.selectedUnit.next(updatedUnit);
    }
  }

  protected unitDataOobservable(unitId: number): Observable<Unit> {
    const expandFields = [
      'hwModel', 'unitType', 'lastMsgUnit', 'endUser', 'activeOrder', 'activeOrder.endUser',
      'endUserPricePlans',
      'endUserPricePlans.translatedName',
      'endUserPricePlans.translatedDescriptionSpeedMode',
      'endUserPricePlans.translatedDescriptionPrice',
      'endUserPricePlans.translatedDescriptionTitle1',
      'endUserPricePlans.translatedDescriptionTitle2',
      'endUserPricePlans.translatedDescriptionTitle3',
      'endUserPricePlans.translatedDescriptionTitle4',
      'endUserPricePlans.translatedDescriptionValue1',
      'endUserPricePlans.translatedDescriptionValue2',
      'endUserPricePlans.translatedDescriptionValue3',
      'endUserPricePlans.translatedDescriptionValue4',
      'availabilityStatus', 'activeOrder.endUserOrderIntervals',
      'speed', 'sats', 'gsm', 'activeOrder.currency_code', 'height',
      'lbsLac', 'lbsCountryCode', 'lbsOperatorId', 'lbsCellId',
      'inRideAllowArea', 'inFinishAllowArea',
      'unitModel', 'unitModel.project', 'hwModel', 'activeOrder.how_order_was_paid', 'battery',
      'lastFinishedOrCancelledOrder',
      'lastFinishedOrCancelledOrder.unitImagesShort.thumbnail',
      'lastFinishedOrCancelledOrder.end_user_full_name',
      'lastFinishedOrCancelledOrder.paymentMethods',
      'lastFinishedOrCancelledOrder.debt',
      'lastFinishedOrCancelledOrder.currency_code',
      'lastFinishedOrCancelledOrder.finish_by_user_name',
    ];
    const url = this.environmentApiBasepoint + 'unit/' + unitId + '?expand=' + expandFields.join(',');
    return this.http.get<any>(url)
      .pipe(
        //   withLatestFrom(this.selectedUnit),
        //   map(([unit, previous]) => {
        //     return unit;
        //   }),
        tap(
          unit => {
            if (!this.skipUnitIfRefreshInProgress[unit.id]) {
              this.selectedUnit.next(unit);
            }
            this.skipUnitIfRefreshInProgress = {};
          }
        )
      );
  }
}
